/**
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 **/

import React, { ReactNode, ReactElement } from 'react';
import Dialog from '@gearz/dialog';

type CustomDialogProps = {
  className?: string,
  id?: string,
  onClose: () => void,
  children?: ReactNode,
  title?: string,
  isOpened: boolean,
};

const defaultProps = {
  id: '',
  className: '',
  children: null,
  title: '',
};

const CustomDialog: React.FC<CustomDialogProps> = ({
  id, onClose, children, className, title, isOpened,
}: CustomDialogProps): ReactElement => (
  <Dialog isOpened={isOpened} id={id} onClose={onClose} className={className}>
    <Dialog.Backdrop />
    <Dialog.Content>
      <Dialog.CloseButton />
      <Dialog.Header>
        {!!title?.length && <h1>{title}</h1>}
        <Dialog.CloseButton />
      </Dialog.Header>
      <Dialog.Body>
        {children}
      </Dialog.Body>
    </Dialog.Content>
  </Dialog>
);

CustomDialog.defaultProps = defaultProps;

export default CustomDialog;
